import {EmptySearchParamsFilterModel} from "../../../../shared/models/search/params/filters/empty-search-params-filter.model";

export class CaCollectionParamsFilterModel extends EmptySearchParamsFilterModel {
    public constructor(
        public karyotype: string,
        public chromosomeAffectedA: string,
        public chromosomeAffectedB: string,
        public chromosomeAffectedC: string,
        public ageMin: number|string,
        public ageMax: number|string
    ) {
        super();
    }
}
